import { render, staticRenderFns } from "./MostrarResultados.vue?vue&type=template&id=0fe24e41&scoped=true&"
import script from "./MostrarResultados.vue?vue&type=script&lang=js&"
export * from "./MostrarResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe24e41",
  null
  
)

export default component.exports